import React from 'react'
import ReactDOM from 'react-dom/client'

// 1. Load Tailwind CSS first (base styles)
import './index.css'

// 2. Load external library CSS
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import 'swiper/swiper-bundle.css'
import 'react-toastify/dist/ReactToastify.css'

// 3. Load critical SCSS files to prevent FOUC (Flash of Unstyled Content)
import './components/Layout/Layout.scss'
import './components/Sidenav/Sidenave.scss'
import './components/Loading/Loading.scss'
import './components/Notfound/Notfound.scss'
import './pages/Auth/Login.scss'

// 4. Load app components
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ToastContainer } from 'react-toastify'
import UserProvider from './Context/Usercontext.js'
import { QueryClient, QueryClientProvider } from 'react-query'

// 5. Initialize CSS preloading
import { initializeCriticalCSS } from './utils/cssPreloader'



import { ReactQueryDevtools } from 'react-query/devtools'

const root = ReactDOM.createRoot(document.getElementById('root'))
const queryClient = new QueryClient()

// Initialize critical CSS preloading
initializeCriticalCSS()

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <App />
      </UserProvider>
      <ToastContainer position='bottom-right' stacked />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
)
reportWebVitals()
